const InfoText = ( { text } ) => {
	return (
		<span className="splw-settings-info">
			<i className="dashicons dashicons-info-outline"></i>
			<span className="splw-settings-info-text">{ text }</span>
		</span>
	);
};
export default InfoText;
